import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noTaxIdentifiersAndIOR: {
    id: 'WdMCiN',
    description: 'Message shown when both Tax identifiers and Importer of Record are not configured',
    defaultMessage:
      'To update orders with Tax identifiers and Importer of Record, add and configure them on the {internationalSettingsLink}.',
  },
  noIOROnly: {
    id: 'sf/j0q',
    description: 'Message shown when only Importer of Record is not configured',
    defaultMessage: 'To update orders with Importer of Record, add and configure Importers of Record on the {internationalSettingsLink}.',
  },
  noTaxIdentifiersOnly: {
    id: 'ikm+Kg',
    description: 'Message shown when only Tax identifiers are not configured',
    defaultMessage: 'To update orders with Tax Identifiers, add and configure Tax Identifiers on the {internationalSettingsLink}.',
  },
  internationalSettingsPage: {
    id: 'dJwShs',
    description: 'Link text for International Settings page',
    defaultMessage: 'International Settings page',
  },
});
